module.exports = __webpack_public_path__ + "static/media/ncc1.d178369a.png";